import { render, staticRenderFns } from "./CompanyStatistics.vue?vue&type=template&id=b77ebc58&scoped=true&"
import script from "./CompanyStatistics.vue?vue&type=script&lang=js&"
export * from "./CompanyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CompanyStatistics.vue?vue&type=style&index=0&id=b77ebc58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77ebc58",
  null
  
)

/* custom blocks */
import block0 from "./CompanyStatistics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b77ebc58')) {
      api.createRecord('b77ebc58', component.options)
    } else {
      api.reload('b77ebc58', component.options)
    }
    module.hot.accept("./CompanyStatistics.vue?vue&type=template&id=b77ebc58&scoped=true&", function () {
      api.rerender('b77ebc58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company-settings/CompanyStatistics.vue"
export default component.exports